import { useDispatch } from "react-redux";
import API from "../../Network/API";
import { useEffect, useState } from "react";

export default function TutorEarning(){
     
     const dispatch = useDispatch();
     const [data,setData]=useState()

        useEffect(() => {
            
            API.get(`/v1/oauth/teacher/earning_history`).then((response) => {
                setData(response.data.data)
            }).catch((error) => {
            });
    
        }, []);

    return (
        <>
         <div className="dashboard-title">
                <h4>Earning History</h4>
            </div>
            <div className="row">
            <div className="col-12">
            <div className="table-responsive custom-table">
                                <table className="table table-nowrap mb-0">
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Course</th>
                                            <th>Lesson</th>
                                            <th>Earning</th>
                                            <th>Fee</th>
                                            <th>Clearance</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                    {!data?.loading && data?.courses?.length > 0 && data?.courses?.map((course, j) => (
                                        <tr key={j}>
                                            <td data-label="Date">{course.created_at}</td>
                                            <td data-label="Course">{course.course_name}</td>
                                            <td data-label="Lesson">{course.lesson_name}</td>
                                            <td data-label="Earning">{course.earning}</td>
                                            <td data-label="Fee">{course.fees}</td>
                                            <td data-label="Clearance">{course?.approved==1? <span className="status-badge ok">Approved</span> : <span className="status-badge pending">Pending</span>}</td>
                                        </tr>
                                     ))}
                                    </tbody>
                                    </table>
                                    </div>
                </div>
                </div>
        </>
    )
}